import type { MessageAttachment } from '@teo/widget-shared';
import { parseVideoEmbedUrl } from '@teo/widget-shared';
import { LinkPreviewCard } from './LinkPreviewCard.js';
import type { LinkPreviewData } from '@teo/widget-shared';

type VideoEmbedPreviewProps = {
  attachment: MessageAttachment;
  onMediaLoad?: () => void;
};

function domainFromWatchUrl(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

function attachmentToPreview(attachment: MessageAttachment): LinkPreviewData {
  const embed = parseVideoEmbedUrl(attachment.url);
  const provider = attachment.provider ?? embed?.provider ?? 'video';
  const videoId = embed?.videoId;

  return {
    url: attachment.url,
    title: provider === 'youtube' ? 'YouTube' : provider === 'vimeo' ? 'Vimeo' : 'Video',
    domain: domainFromWatchUrl(attachment.url),
    embedUrl: attachment.embedUrl ?? embed?.embedUrl,
    provider,
    imageUrl:
      provider === 'youtube' && videoId
        ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
        : undefined,
  };
}

export function VideoEmbedPreview({
  attachment,
  onMediaLoad,
}: VideoEmbedPreviewProps) {
  return (
    <LinkPreviewCard
      preview={attachmentToPreview(attachment)}
      onMediaLoad={onMediaLoad}
    />
  );
}
